// extracted by mini-css-extract-plugin
export var actionButton = "_j8-t";
export var buttonContainer = "_j8-0";
export var buttonContainer2 = "_j8-1";
export var buttonSection = "_j8-2";
export var details = "_j8-3";
export var dropdownItem = "_j8-5";
export var dropdownItemsContainer = "_j8-4";
export var fileInput = "_j8-r";
export var headerButton = "_j8-6";
export var icon = "_j8-7";
export var input = "_j8-8";
export var macroListItem = "_j8-9";
export var mainContent = "_j8-a";
export var microText = "_j8-b";
export var modal = "_j8-w";
export var optionsButton = "_j8-c";
export var paperclip = "_j8-s";
export var pillContent = "_j8-d";
export var preview = "_j8-e";
export var preview2 = "_j8-f";
export var quillEditor = "_j8-q";
export var selectedMacro = "_j8-g";
export var sidebar = "_j8-h";
export var sidebarHeader = "_j8-j";
export var sidebarList = "_j8-i";
export var sidebarListItem = "_j8-k";
export var sidebarSearch = "_j8-l";
export var snoozeDurationWrapper = "_j8-v";
export var statusPillContainer = "_j8-m";
export var tagsContainer = "_j8-n";
export var unselectedMacro = "_j8-o";
export var variable = "_j8-u";
export var wrapper = "_j8-p";